import React from 'react';
import { Automation } from '../../types/automatisation.types';
import { AutomatisationItem } from '../AutomatisationItem';
import './AutomatisationList.css';

interface AutomatisationListProps {
  automations: Automation[];
  onEdit: (automation: Automation) => void;
  onDelete: (id: string) => void;
  onToggle: (id: string) => void;
  onExecute: (id: string) => void;
  onViewHistory: (automation: Automation) => void;
}

export const AutomatisationList: React.FC<AutomatisationListProps> = ({
  automations,
  onEdit,
  onDelete,
  onToggle,
  onExecute,
  onViewHistory
}) => {
  return (
    <div className="admin-automatisation-list">
      {automations.map((automation) => (
        <AutomatisationItem
          key={automation.id}
          automation={automation}
          onEdit={() => onEdit(automation)}
          onDelete={() => onDelete(automation.id)}
          onToggle={() => onToggle(automation.id)}
          onExecute={() => onExecute(automation.id)}
          onViewHistory={() => onViewHistory(automation)}
        />
      ))}
    </div>
  );
};